<template>
	<div class="container">
		<!-- 菜单导航 -->
		<Menu></Menu>
		<div class="personal-center">
			<div class="personal-main-top">
				<div>
					<div>
						<div class="head-image-box">
							<img :src="userList.avatar_url" />
						</div>
						<p class="editor-material-wrap" @click="openEditUser">
							<span class="editor-material">
								<span class=" iconfont icon-bianji"></span>
								账号设置
							</span>
						</p>
						<p class="login-name">{{ userList.nickname }}</p>
					</div>
				</div>
			</div>
			<div class="personal-main">
				<div class="sticky">
					<el-tabs :tab-position="tabPosition" @tab-click="tabsClick">
						<el-tab-pane label="我的课程">
							<div class="personal-content_flex">
								<div class="personal-main-content">
									<div class="formal-container">
										<div class="personal-empty" v-if="formalClass.length < 1">
											<img src="@/assets/personal/img04.png" alt="" class="empty-img" />
											<span class="empty-txt">您还未报名正式课～</span>
										</div>
										<div class="infinite-list-wrapper" style="overflow:auto">
											<p v-if="formalClass.length > 0"
												style="color:#212529; height: 28px; font-size: 20px;line-height: 28px;font-weight:bolder;text-align:left;">
												已开通的课程服务列表</p>
											<div class="formClassbox" @click="showCourse(item.id)"
												v-for="(item, i) in formalClass" :key="i">
												<img :src="item.thumb" alt="" style="width:228px;height:152;">
												<div class="right">
													<h2>{{ item.title }}</h2>
													<p>{{ item.study_num }}人看过</p>
												</div>
											</div>
											<div class="pagefooter">
												<el-pagination background layout="prev, pager, next" prev-text="上一页"
													next-text="下一页" :total="courseTotal" :page-size="10"
													@current-change="currentChange" @prev-click="prevClick"
													@next-click="nextClick">
												</el-pagination>
											</div>

										</div>
									</div>
								</div>
							</div>
						</el-tab-pane>
						<el-tab-pane label="我的发布">
							<div class="personal-content_flex">
								<div class="personal-main-content">
									<div class="formal-container">
										<!-- <div class="my_tabs">
                      <div class="my_tab_item" :class="mytab_index == i ? 'my_islink' : ''" v-for="(item, i) in mytabs"
                        @click="tabsMyClick(i)" :key="i">
                        {{ item.val }}
                      </div>
                    </div> -->
										<Post :listData="postData"></Post>
										<div class="personal-empty" v-if="postData.length < 1">
											<img src="../assets/personal/zuopin.png" alt="" class="empty-img" />
											<span class="empty-txt">没有找到相关内容~</span>
										</div>
									</div>
								</div>
							</div>
						</el-tab-pane>
						<el-tab-pane label="我的订单">
							<div class="personal-content_flex">
								<div class="personal-main-content">
									<div class="formal-container">
										<div class="personal-empty" v-if="orderData.length < 1">
											<img src="../assets/personal/yuedu.png" alt="" class="empty-img" />
											<span class="empty-txt">您还未没有订单哦～</span>
										</div>
										<div>
											<!-- <p v-if="orderData.length > 0" style="height: 28px; font-size: 20px;line-height: 28px;font-weight:bolder;text-align:left;">
                        已开通的课程服务列表</p> -->
											<el-card class="box_card_order" v-for="(item, i) in orderData" :key="i">
												<div slot="header" class="orderheader">
													<span>订单编号：{{ item.order_sn }}</span>
													<span>时间：{{ item.create_time }}</span>
													<span>订单状态：{{ item.status_text }}</span>
												</div>
												<div class="orderbox">
													<img :src="item.detail[0] == null ? '' : item.detail[0].course_thumb"
														alt="" style="">
													<div class="right">
														<h2>{{ item.detail[0] == null ? '' : item.detail[0].course_title }}
														</h2>
														<p class="chusiprice">
															￥{{ item.detail[0] == null ? '' : item.detail[0].original_price }}
														</p>
													</div>
												</div>
											</el-card>
										</div>
									</div>
								</div>
							</div>
						</el-tab-pane>
						<el-tab-pane label="我的喜欢">
							<div class="personal-content_flex">
								<div class="personal-main-content">
									<div class="formal-container">
										<!-- <div class="my_tabs">
                      <div class="my_tab_item" :class="mytab_index == i ? 'my_islink' : ''" v-for="(item, i) in mytabs"
                        @click="tabsMyClickLike(i)" :key="i">
                        {{ item.val }}
                      </div>
                    </div> -->
										<Post :listData="postData"></Post>
										<div class="personal-empty" v-if="postData.length < 1">
											<img src="../assets/personal/zuoye.png" alt="" class="empty-img" />
											<span class="empty-txt">没有找到相关内容~</span>
										</div>
									</div>
								</div>
							</div>
						</el-tab-pane>
						<el-tab-pane label="我的收藏">
							<div class="personal-content_flex">
								<div class="personal-main-content">
									<div class="formal-container">
										<!-- <div class="my_tabs">
                      <div class="my_tab_item" :class="mytab_index == i ? 'my_islink' : ''" v-for="(item, i) in mytabs"
                        @click="tabsMyClickSc(i)" :key="i">
                        {{ item.val }}
                      </div>
                    </div> -->
										<Post :listData="postData"></Post>
										<div class="personal-empty" v-if="postData.length < 1">
											<img src="../assets/personal/img04.png" alt="" class="empty-img" />
											<span class="empty-txt">没有找到相关内容~</span>
										</div>
									</div>
								</div>
							</div>
						</el-tab-pane>
					</el-tabs>
					<div class="personal-main-right">
						<div class="userinfo-box">
							<div class="userinfo-trends">
								<div class="content-box">
									<!--          <div>
                    <div>{{ userList.focus_num }}</div>
                    <div>关注</div>
                  </div>
                  <p class="line"></p>
                  <div>
                    <div>{{ userList.fans_num }}</div>
                    <div>粉丝</div>
                  </div> -->
									<div>
										<div>{{ userList.post_num }}</div>
										<div>发布</div>
									</div>

									<div style="height:auto !important;">
										<div>{{ userList.collect_num }}</div>
										<div>收藏</div>
									</div>

									<div>
										<div>{{ userList.like_num }}</div>
										<div>喜欢</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 底部链接 -->
		<Footer></Footer>
	</div>
</template>
<script>
	import Post from '@/components/view/Main/Post'
	import Menu from '@/components/view/Menu'
	import Footer from '@/components/view/Footer'
	export default {
		name: 'personl',
		components: {
			Menu,
			Footer,
			Post
		},
		data() {
			return {
				userList: [],
				tabPosition: 'left',
				formalClass: [], //正式课
				coursePage: 1,
				courseTotal: 0,
				experienceClass: [], //体验课
				postData: [], //我的发布
				likeData: [], //我的喜欢
				scData: [], //我的收藏
				orderData: [], //订单
				mytabs: [{
						id: 1,
						val: "动态"
					},
					{
						id: 2,
						val: "阅读"
					},
					{
						id: 3,
						val: "作业"
					},
					{
						id: 4,
						val: "作品"
					},

				],
				mytab_index: "",
				mytabs_value: "",
				empty_txt: '暂无内容',
				empty_txt_like: "",
				empty_txt_sc: "",
				empty_imgUrl: "",
				empty_imgUrl_like: "",
				empty_imgUrl_sc: ""
			}
		},
		created() {
			this.userInfo()
			this.myCourse()
		},
		methods: {
			myCourse() {
				this.$axios({
					method: 'post', // 请求格式
					url: '/api/user/myCourse', // 请求路径
					headers: { // 设置请求头
						token: this.$cookieStore.getCookie('token')
					},
					data: {
						type: "2",
						limit: 10,
						page: this.coursePage
					}
				}).then(res => {
					this.formalClass = res.data.data.data //正式课数据
					this.courseTotal = res.data.data.total;
				}).catch(err => {
					console.log(err)
				})
			},
			currentChange(e) {
				this.coursePage = e
				this.myCourse()
			},
			prevClick(e) {
				this.coursePage = e
				this.myCourse()
			},
			nextClick(e) {
				this.coursePage = e
				this.myCourse()
			},
			userInfo() {
				this.$axios({
					method: 'post', // 请求格式
					url: '/api/user/userInfo', // 请求路径
					headers: { // 设置请求头
						token: this.$cookieStore.getCookie('token')
					}
				}).then(res => {
					this.userList = res.data.data
				}).catch(err => {
					console.log(err)
				})

				this.$axios({
					method: 'post', // 请求格式
					url: '/api/user/myOrder', // 请求路径
					headers: { // 设置请求头
						token: this.$cookieStore.getCookie('token')
					}
				}).then(res => {
					this.orderData = res.data.data.data
					console.log("order", res.data.data.data)
				}).catch(err => {
					console.log(err)
				})

			},

			showCourse(id) {
				this.$router.push({
					path: "/courseclasses",
					query: {
						id: id
					}
				})
			},

			openEditUser() {
				this.$router.push("/PersonalEdit")
			},

			tabsMyClickSc(i) {
				this.mytab_index = i
				this.$axios({
					method: 'post', // 请求格式
					url: '/api/user/myCollect', // 请求路径
					headers: { // 设置请求头
						token: this.$cookieStore.getCookie('token')
					},
					data: {
						type: i + 1
					}
				}).then(res => {
					this.postData = res.data.data.data

				}).catch(err => {
					console.log(err)
				})
				switch (i) {
					case 0:
						this.mytabs_value = "动态"
						this.empty_txt_sc = "您还未收藏动态～"
						this.empty_imgUrl_sc = require("@/assets/personal/img04.png")
						break;
					case 1:
						this.mytabs_value = "阅读"
						this.empty_txt_sc = "您还未收藏阅读知识～"
						this.empty_imgUrl_sc = require("@/assets/personal/yuedu.png")
						break;
					case 2:
						this.mytabs_value = "作业"
						this.empty_txt_sc = "您还未收藏作业～"
						this.empty_imgUrl_sc = require("@/assets/personal/zuoye.png")

						break;
					case 3:
						this.mytabs_value = "作品"
						this.empty_txt_sc = "您还未收藏作品～"
						this.empty_imgUrl_sc = require("@/assets/personal/zuopin.png")
						break;
					default:
						break;
				}
			},

			// 左侧tab切换
			tabsClick(e) {
				var index = e.index;
				if (index == 1) {
					this.MyPost();
				} else if (index == 3) {
					this.MyLike();
				} else if (index == 4) {
					this.MyCollect();
				}
			},

			MyPost() {
				this.$axios({
					method: 'post', // 请求格式
					url: '/api/user/myPost', // 请求路径
					headers: { // 设置请求头
						token: this.$cookieStore.getCookie('token')
					},
				}).then(res => {
					this.postData = res.data.data.data
				}).catch(err => {
					console.log(err)
				})
			},
			MyCollect() {
				this.$axios({
					method: 'post', // 请求格式
					url: '/api/user/myCollect', // 请求路径
					headers: { // 设置请求头
						token: this.$cookieStore.getCookie('token')
					},
				}).then(res => {
					this.postData = res.data.data.data
				}).catch(err => {
					console.log(err)
				})
			},

			MyLike() {
				this.$axios({
					method: 'post', // 请求格式
					url: '/api/user/myLike', // 请求路径
					headers: { // 设置请求头
						token: this.$cookieStore.getCookie('token')
					},
				}).then(res => {
					this.postData = res.data.data.data
				}).catch(err => {
					console.log(err)
				})
			}

		}
	}
</script>

<style lang="scss" scoped>
	.pagefooter {
		display: inline-block;
		width: 100%;
		text-align: center;
		margin: 30px 0;
		margin-bottom: 50px;

		/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
			background-color: #FABE00;
			border: none;
			color: #fff;
		}

		/deep/ .el-pager li {
			border-radius: 8px;
			background-color: #fff;
			border: 1px solid #eaeaea;

			&:hover {
				color: #3dc57c;
			}
		}

		/deep/ .btn-prev {
			border-radius: 8px;
			background-color: #fff;
			border: 1px solid #eaeaea;
			padding: 0 10px;
		}

		/deep/ .btn-next {
			border-radius: 8px;
			background-color: #fff;
			border: 1px solid #eaeaea;
			padding: 0 10px;
		}
	}

	/deep/.el-image-viewer__mask {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		opacity: 1 !important;
		background: #000;
	}

	.video_box {
		width: 100%;
		padding: 15px;

		.video-player {
			width: 400px;
			height: 250px;
			display: flex;
		}

		/deep/ .vjs-custom-skin>.video-js .vjs-big-play-button {
			background-color: rgba(0, 0, 0, 0.45);
			font-size: 2.5em;
			width: 4rem;
			/* border-radius: 50%; */
			height: -7em !important;
			/* line-height: 2em !important; */
			margin-top: -1em !important;
		}

		/deep/ .vjs-custom-skin>.video-js .vjs-control {
			width: 3rem
		}

		/deep/ .video-js .vjs-tech {
			object-fit: fill;
		}

		/deep/ .vjs-poster {
			background-size: cover;
		}

		/deep/.vjs-custom-skin>.video-js .vjs-big-play-button {
			top: 50%;
			left: 50%;
			margin-left: -1.5em;
			margin-top: -1em;
		}
	}

	/deep/ .el-image img {
		width: 100%;
	}

	.personal-center {
		margin: 0 auto 30px;

		.personal-content_flex {
			.personal-main-content {
				.formal-container {
					.image_box_person {
						width: 100%;
						padding: 15px;
						display: flex;
						flex-wrap: wrap;

						.el-image {
							width: 185px;
							height: 120px;
							margin-top: 7px;
							margin-right: 7px;
						}

					}


					/deep/ .el-tabs__item .is-active {
						background: #0000 !important;
						color: #0000 !important;
					}

					/deep/ .el-tabs__header {
						width: 100% !important;
					}

					/deep/ .el-tabs__header .el-tabs__item.is-active {
						background: none !important;
						color: #0000 !important;
						margin: 0;
					}

					/deep/ .el-tabs__item {
						width: 50px !important;
					}
				}
			}
		}
	}

	.context_fb_main {
		padding: 10px;
		display: flex;
		margin-bottom: 10px;

		.fb_content_right {
			.fb_avator_text {
				display: flex;
				margin-bottom: 10px;

				img {
					width: 40px;
					height: 40px;
					border-radius: 50%;
				}

				h2 {
					font-size: 14px;
					font-family: PingFangSC-Medium, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
					font-weight: 600;
					color: #18252c;
				}

				.uusertimer {
					margin-left: 10px;
					text-align: left;

					p {
						font-size: 12px;
						font-family: PingFangSC-Regular, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
						font-weight: 400;
						color: #9fa4a7;
						line-height: 17px;
						margin-top: 2px;
						cursor: auto;
					}
				}


			}

			.textarea_fb_text {
				text-indent: 2rem;

				font-size: 14px;
				text-align: left;
				text-indent: 2rem;
				font-family: PingFangSC-Regular, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
				font-weight: 500;
				color: #18252c;
				line-height: 24px;
				margin-top: 15px;
				margin-bottom: 12px;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 3;
				overflow: hidden;
				cursor: pointer;
				word-wrap: break-word;
				word-break: break-word;
			}
		}
	}

	.my_tabs {
		display: flex;
		background: rgb(245, 248, 248);
		padding: 10px 20px;
		border-radius: 13px;

		.my_islink {
			background: #fff;
			padding: 4px 7px;
			border-radius: 8px;
			color: #FABE00 !important;
		}

		.my_tab_item {
			margin-right: 5px;

			text-align: center;
			min-width: 56px;
			padding: 0 12px;
			height: 24px;
			font-size: 16px;
			font-family: PingFangSC-Regular, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
			font-weight: 600;
			color: #747c80;
			line-height: 24px;
			box-sizing: border-box;
			cursor: pointer;

			&:hover {
				color: #FABE00;
			}




		}
	}

	.fabuTabsBox {
		display: flex;
		flex-direction: column;

		height: 100%;
		line-height: 0;
		text-align: center;
		border-radius: 0px;
		background: none;
	}

	/deep/ .el-tabs__nav {
		padding: 0 10px;
	}

	/deep/ .el-tabs__header {
		background-color: #f5f8f8;
	}

	/deep/ .el-tabs__item.is-active {
		background: #FABE00;
		color: #fff !important;
	}

	/deep/.el-tabs__header {
		width: 133px;
		background: #f5f8f8;
		margin: 0;
		border-radius: 6px;
	}

	/deep/ .el-tabs__item {
		width: 100% !important;
		height: 45px;
		line-height: 45px;
		margin: 10px auto;
	}

	/deep/ .el-tabs__item.is-active {
		background: #FABE00;
		color: #fff;
		width: 85%;
		margin: 10px auto;
		height: 45px;
		line-height: 45px;
		text-align: center;
		border-radius: 10px;
	}

	.img-tag {
		display: flex;
		justify-content: flex-start;
		margin-top: 40px;

		.college-tag {
			padding: 0 9px;
			height: 24px;
			background: #f7f7f7;
			border-radius: 12px;
			font-size: 12px;
			font-family: PingFangSC-Regular, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
			font-weight: 400;
			color: #465156;
			line-height: 24px;
			text-align: center;
			cursor: auto;
		}

		.college-tag-courseType {
			margin-left: 8px;
		}

		.img-tag-right {
			display: flex;
			margin-top: 15px;
			margin-left: 400px;
			font-size: 12px;
			font-family: PingFangSC-Regular, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
			font-weight: 500;
			color: #747c80;
		}

		.collect-box {
			box-sizing: border-box;
			width: 74px;
			display: flex;
			align-items: center;
			cursor: pointer;
		}

		.collect-box img {
			width: 24px;
			vertical-align: text-bottom;
			margin-right: 4px;
		}

		.collect-box span {
			font-family: PingFangSC-Medium, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
			font-size: 12px;
			font-weight: 500;
			color: #747c80;
		}

		.line {
			width: 100%;
			height: 1px;
			background: #e6e6e6;
			border-radius: 9px;
			margin-top: 20px;
		}

		.praise-box {
			width: 74px;
			display: flex;
			align-items: center;
			cursor: pointer;
		}

		.praise-box img {
			width: 24px;
			vertical-align: text-bottom;
			margin-right: 4px;
		}

		.praise-box span {
			font-family: PingFangSC-Medium, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
			font-size: 12px;
			font-weight: 500;
			color: #747c80;
		}

		.comment-box {
			display: flex;
			align-items: center;
			width: 74px;
			cursor: pointer;
		}

		.img-tag-right img {
			width: 24px;
			vertical-align: text-bottom;
			margin-right: 4px;
		}

		.comment-box span {
			font-family: PingFangSC-Medium, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
			font-size: 12px;
			font-weight: 500;
			color: #747c80;
		}

		.share__wrap {
			position: relative;
		}

		.share_box {
			display: flex;
			align-items: center;
			width: 74px;
			height: 100%;
			cursor: pointer;
		}

		.share__icon {
			display: inline-block;
			width: 24px;
			height: 24px;
			vertical-align: middle;
			transition: background .2s ease-in-out;
			background: url('~@/assets/circle/img14.png') 100% 100% no-repeat;
			background-size: 100%;
			margin-right: 4px;
		}

		.share__label {
			font-size: 12px;
			font-family: PingFangSC-Medium, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
			font-weight: 500;
			color: #747c80;
			line-height: 16px;
		}
	}

	.box_card_order {
		margin-bottom: 25px;
	}

	.orderbox {
		display: flex;

		text-align: left;

		img {
			width: 228px;
			height: 142px;
			border-radius: 6px;
			overflow: hidden;
			margin-right: 20px;
		}

		.chusiprice {
			color: rgb(255, 124, 6);
			margin-top: 70px;
			font-weight: 700;
			font-size: 20px;
		}

		.zuiyou {
			text-align: left;
			margin-left: 160px;
			margin-top: 15px;

			.liji {
				background: rgb(255, 124, 6);
				color: #fff;
				border-radius: 20px;
				padding: 8px 14px;
				margin-top: 10px;
			}

			.cancel {
				background: #fff;
				color: rgb(123, 119, 119);
				border-radius: 20px;
				padding: 8px 14px;
				margin-top: 10px;
			}
		}
	}

	.orderheader {
		text-align: left;
		font-size: 13px;

		span {
			margin-right: 80px;

		}
	}
</style>
<style scoped>
	.img_box {
		display: flex;
		overflow: hidden;
		width: 100%;
		position: relative;
	}

	.imgk {
		width: 185px;
		height: 120px;
		margin-right: 10px;
		margin-bottom: 10px;
		border-radius: 10px;
		cursor: pointer;

		&:last-child {
			margin-right: 0;
		}
	}

	.imgk img {
		width: 100%;
	}

	.sticky .el-tabs__item {
		font-size: 15px !important;
	}

	.formClassbox {
		display: flex;
		margin-top: 30px;
	}

	.formClassbox img {
		height: 152px;
		border-radius: 8px;
	}

	.formClassbox .right {
		text-align: left;
		padding-left: 15px;
	}

	.formClassbox h2 {
		font-size: 19px;
		font-weight: bold;
		color: #18252C;
		margin: 0px 0 10px 0;
	}

	.personal-center {
		width: 1200px;
		margin: 0 auto;
	}

	.personal-main {
		width: 1200px;
		margin: 20px auto 0;
		/* display: flex; */
		align-items: flex-start;
		justify-content: space-between;
	}

	.sticky {
		position: -webkit-sticky;
		position: sticky;
		top: 90px;
		z-index: 99;
		width: 100%;
		background: #fff;
		border-radius: 6px;
		display: flex;
	}

	.personal-content_flex {
		display: flex;
	}

	.personal-main-content {
		width: 780px;
		min-height: 430px;
		margin: 0 20px;
	}

	.personal-main-right {
		width: 247px;
		position: -webkit-sticky;
		position: sticky;
		top: 90px;
		z-index: 99;
	}

	.userinfo-box {
		width: 247px;
		margin-bottom: 24px;
	}

	.content-box {
		background: #f5f8f8;
		border-radius: 8px;
		width: 100%;
		height: 82px;
		padding: 20px 2px;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
	}

	.content-box>div {
		width: 80px;
		text-align: center;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
		font-weight: 400;
		color: #465156;
		line-height: 20px;
	}

	/* .content-box>div:first-child{
                  height: 20px;
                } */
	.content-box>div:nth-child(2) {
		margin-top: 2px;
		height: 20px;
	}

	.line {
		width: 1px;
		height: 20px;
		background-color: #e5e5e5;
	}

	.personal-empty {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		margin-top: 60px;
		padding-bottom: 62px;
	}

	.empty-img {
		width: 240px;
		height: 126px;
	}

	.empty-txt {
		margin-top: 12px;
		width: -webkit-max-content;
		width: -moz-max-content;
		width: max-content;
		height: 20px;
		font-size: 14px;
		font-family: PingFangSC-Semibold, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
		font-weight: 600;
		color: #8d8e8e;
		line-height: 20px;
	}

	.personal-main-top {
		width: 1200px;
		height: 278px;
		background: url('~@/assets/personal/img01.png') 50% no-repeat;
		background-size: 1200px 278px;
		border-radius: 5px;
		overflow: hidden;
		margin: 33px 0 20px;
	}

	.personal-main-top>div {
		margin: 85px auto 0;
		text-align: center;
	}

	.personal-main-top>div img {
		box-shadow: 0 0 10px 0 rgb(0 0 0 / 10%);
		border: 5px solid #fff;
	}

	.head-image-box img {
		height: 100px;
		width: 100px;
		border-radius: 50%;
	}

	.editor-material-wrap {
		margin-top: -26px;
		cursor: pointer;
	}

	.editor-material {
		display: inline-block;
		width: 88px;
		height: 26px;
		background: #ffe500;
		border-radius: 15px;
		font-size: 12px;
		font-family: PingFangSC-Medium, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
		font-weight: 500;
		color: #18252c;
		line-height: 28px;
	}

	.personal-main-top .editor-material-img {
		width: 12px;
		height: 12px;
		vertical-align: middle;
		border: none;
	}

	.login-name {
		font-size: 20px;
		font-family: PingFangSC-Medium, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
		font-weight: 500;
		color: #fff;
		line-height: 28px;
		text-shadow: 0 2px 4px rgb(0 0 0 / 50%);
		margin-top: 12px;
	}

	/deep/ .el-tabs--left .el-tabs__header.is-left {
		height: 320px;
	}
</style>


// WEBPACK FOOTER //
// src/components/Personal.vue